import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import FieldView2 from 'core/components/layout/FieldView2';


export default function PartyInfoForTableRow({partyObj}){
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll",  maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{}}
      >
            
        {/* <Grid item lg={4} xs={6}><FieldView label="Title"  value={ partyObj.title!==null && partyObj.title!==undefined?partyObj.title:'NOT KNONWN' }/></Grid> */}
        <Grid item lg={2} xs={6}><FieldView2 label="Contact"  value={ partyObj.contact!==null && partyObj.contact!==undefined?partyObj.contact:'NOT KNONWN' }/></Grid>
        <Grid item lg={2} xs={6}><FieldView2 label="Drug License"  value={ partyObj.druglicense!==null && partyObj.druglicense!==undefined?partyObj.druglicense:'NOT KNONWN' }/></Grid>
        <Grid item lg={2} xs={6}><FieldView2 label="GST"  value={ partyObj.gst!==null && partyObj.gst!==undefined?partyObj.gst:'NOT KNONWN' }/></Grid>
        <Grid item lg={2} xs={6}><FieldView2 label="Contact Mobile"  value={ partyObj.contactmobile!==null && partyObj.contactmobile!==undefined?partyObj.contactmobile:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Corporate Email"  value={ partyObj.corporateemail!==null && partyObj.corporateemail!==undefined?partyObj.corporateemail:'NOT KNONWN' }/></Grid>
        
        
        <Grid item lg={4} xs={6}><FieldView2 label="Address"  value={ partyObj.address!==null && partyObj.address!==undefined?partyObj.address:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Dispatch Address"  value={ partyObj.dispatchaddress!==null && partyObj.dispatchaddress!==undefined?partyObj.dispatchaddress:'NOT KNONWN' }/></Grid>
        {/* <Grid item lg={4} xs={6}><FieldView label="Same Address"  value={ partyObj.sameaddress!==null && partyObj.sameaddress!==undefined?partyObj.sameaddress:'NOT KNONWN' }/></Grid> 
        <Grid item lg={4} xs={6}><FieldView label="Order Value"  value={ partyObj.ordervalue!==null && partyObj.ordervalue!==undefined?partyObj.ordervalue:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView label="Business Id"  value={ partyObj.businessid!==null && partyObj.businessid!==undefined?partyObj.businessid:'NOT KNONWN' }/></Grid> 
        <Grid item lg={4} xs={6}><FieldView label="Status Id"  value={ partyObj.statusid!==null && partyObj.statusid!==undefined?partyObj.statusid:'NOT KNONWN' }/></Grid>*/}
        
        <Grid item lg={4} xs={6}><FieldView2 label="Status"  value={ partyObj.statusname==='' || partyObj.statusname===null?'DRAFT':partyObj.statusname }/></Grid>

        {partyObj.statusname==='APPROVED'?
        <Grid item lg={4} xs={6}><FieldView2 label="Active"  value={ partyObj.status?'Active':'Disabled' }/></Grid>
        :<></>}
      </Grid>
      </Grid>
      </Box>
    )
}